import React, { useState, useEffect } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import { Button, Dropdown, Menu, Popconfirm, Timeline, Card, Row, Col } from 'antd';
import { PlusOutlined, DownOutlined, EditOutlined, DeleteOutlined,PlusCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { activityService, propertyService } from '@iso/services';
import _ from 'lodash';
import moment from 'moment';
import PropertyManagePage from './Property.styles';

const UserHistory = (props) => {
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const activePermission = useSelector((state) => state.permission.activePermission);
  const dispatch = useDispatch();
  const [userHistory, setUserHistory] = useState([]);

  useEffect(() => {
    if(props.propertyId){
      propertyService.getListUsersOfProperty(props.propertyId).then(res => {
        if(res.code === '0000'){
          setUserHistory(res.users);
        }
      });
    }
  }, [props.propertyId]);

  return (
    <PropertyManagePage>
      <div style={{ width: "100%"}}>
      <br/>
        <Timeline>
         {(userHistory) ? (userHistory.map((value, index) => {
              if(value){
                 return  (
                //  <Timeline.Item color="green" key={index}>
                <>
                            <p className='cstmData'>{moment(value.created_at).format('ll')}</p>
                            <Card  className='title' title="User Information" bordered={true}>
                              <Row>
                                <Col xs={{span: 9}} md={{span: 9}}>
                                  <p className="content">User Name</p> 
                                </Col>
                                <Col xs={{span: 13, offset: 2}} md={{span: 13, offset: 2}}>
                                 <b className="cardValue">{value.name}</b>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={{span: 9}} md={{span: 9}}>
                                  <p className="content">Email</p> 
                                </Col>
                                <Col xs={{span: 13, offset: 2}} md={{span: 13, offset: 2}}>
                                 <b className="cardValue">{value.email}</b>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={{span: 9}} md={{span: 9}}>
                                  <p className="content">Mobile Phone</p> 
                                </Col>
                                <Col xs={{span: 13, offset: 2}} md={{span: 13, offset: 2}}>
                                 <b className="Value">{value.mobile_phone}</b>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={{span: 9}} md={{span: 9}}>
                                  <p className="content">Permission</p> 
                                </Col>
                                <Col xs={{span: 13, offset: 2}} md={{span: 13, offset: 2}}>
                                 <b className="cardValue">{value.permission}</b>
                                </Col>
                              </Row>
                            </Card>
                            </>
                          )
              }
              return false
          })) : ''}
        </Timeline>
      </div>
    </PropertyManagePage>
  )
}

export default UserHistory;